import React, { memo, useCallback, useState, useEffect } from 'react'
import { getSession, closeSession } from "../helper/UserProfile";
import { Navigate, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import AddUpperBanner from '../components/AddUpperBanner';
import AddLowerBanner from '../components/AddLowerBanner';
import AddEE from '../components/AddEE';
import ReportContainer from '../components/ReportContainer';
import ShowNews from '../components/ShowNews';
import AddNormat from '../components/AddNormat';
import AddRubros from '../components/AddRubros';
import UpperHeader from '../components/UpperHeader';
import AboutUsContainer from '../components/AboutUsContainer';
import DeclarationContainer from '../components/DeclarationContainer';
import ObserverContainer from '../components/ObserverContainer';
import InitialMessageContainer from '../components/InitialMessageContainer';
import EticContainer from '../components/EticContainer';
import AvisoContainer from '../components/AvisoContainer';

const Admin = memo(() => {
    let isLogged = getSession("logged");
    const navigate = useNavigate();

    function closeSess(params) {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="AlertUI">
                        <h1>Aviso</h1>
                        <p>¿Deseas cerrar la sesión actual?</p>
                        <button onClick={onClose}>Quedarme</button>
                        <button
                            onClick={() => {
                                closeSession("logged");
                                closeSession("name");
                                closeSession("user_id");
                                closeSession("type_user");
                                onClose();
                                navigate("/");
                            }}
                        >
                            Salir
                        </button>
                    </div>
                );
            },
        });
    }

    return (
        <> {!isLogged ? (
            <Navigate to="/login" />
        ) : (
            <div className='container-fluid'>
                <UpperHeader child={false} />
                <hr />
                <div className="row">
                    <div className="col-md-12 text-end pb-4">
                        <button className="btn btn-secondary" onClick={() => { navigate("/") }}>Regresar a la página</button>&nbsp;
                        <button className="btn btn-success" onClick={closeSess}>Cerrar Sesión</button>
                    </div>
                </div>
                <div className='container pb-2'>
                    <ul className="nav nav-pills justify-center" id="pills-tab" role="tablist">
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control active" id="pills-bs-tab" data-bs-toggle="pill" data-bs-target="#pills-bs" type="button" role="tab" aria-controls="pills-bs" aria-selected="true">Banner Superior</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-news-tab" data-bs-toggle="pill" data-bs-target="#pills-news" type="button" role="tab" aria-controls="pills-news" aria-selected="false">Noticias</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-bi-tab" data-bs-toggle="pill" data-bs-target="#pills-bi" type="button" role="tab" aria-controls="pills-bi" aria-selected="false">Banner Inferior</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-ee-tab" data-bs-toggle="pill" data-bs-target="#pills-ee" type="button" role="tab" aria-controls="pills-ee" aria-selected="false">Estrados Electrónicos</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-normativa-tab" data-bs-toggle="pill" data-bs-target="#pills-normativa" type="button" role="tab" aria-controls="pills-normativa" aria-selected="false">Normativa</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-rubors-tab" data-bs-toggle="pill" data-bs-target="#pills-rubors" type="button" role="tab" aria-controls="pills-rubors" aria-selected="false">Rubros</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-reports-tab" data-bs-toggle="pill" data-bs-target="#pills-reports" type="button" role="tab" aria-controls="pills-reports" aria-selected="false">Reportes</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-aboutus-tab" data-bs-toggle="pill" data-bs-target="#pills-aboutus" type="button" role="tab" aria-controls="pills-aboutus" aria-selected="false">¿Quiénes Somos?</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-initialmessage-tab" data-bs-toggle="pill" data-bs-target="#pills-initialmessage" type="button" role="tab" aria-controls="pills-initialmessage" aria-selected="false">Mensaje Inicial</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-declara-tab" data-bs-toggle="pill" data-bs-target="#pills-declara" type="button" role="tab" aria-controls="pills-declara" aria-selected="false">Declaración</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-observer-tab" data-bs-toggle="pill" data-bs-target="#pills-observer" type="button" role="tab" aria-controls="pills-observer" aria-selected="false">Observador Ciudadano</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-etic-tab" data-bs-toggle="pill" data-bs-target="#pills-etic" type="button" role="tab" aria-controls="pills-etic" aria-selected="false">Código de Etica</button>
                        </li>
                        <li className="nav-item navHead" role="presentation">
                            <button className="nav-link form-control" id="pills-aviso-tab" data-bs-toggle="pill" data-bs-target="#pills-aviso" type="button" role="tab" aria-controls="pills-aviso" aria-selected="false">Avisos de Privacidad</button>
                        </li>
                    </ul>
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-bs" role="tabpanel" aria-labelledby="pills-bs-tab">
                            <AddUpperBanner />
                        </div>
                        <div className="tab-pane fade" id="pills-news" role="tabpanel" aria-labelledby="pills-news-tab">
                            <ShowNews />
                        </div>
                        <div className="tab-pane fade" id="pills-bi" role="tabpanel" aria-labelledby="pills-bi-tab">
                            <AddLowerBanner />
                        </div>
                        <div className="tab-pane fade" id="pills-ee" role="tabpanel" aria-labelledby="pills-ee-tab">
                            <AddEE />
                        </div>
                        <div className="tab-pane fade" id="pills-normativa" role="tabpanel" aria-labelledby="pills-normativa-tab">
                            <AddNormat />
                        </div>
                        <div className="tab-pane fade" id="pills-rubors" role="tabpanel" aria-labelledby="pills-rubors-tab">
                            <AddRubros />
                        </div>
                        <div className="tab-pane fade" id="pills-reports" role="tabpanel" aria-labelledby="pills-reports-tab">
                            <ReportContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-aboutus" role="tabpanel" aria-labelledby="pills-aboutus-tab">
                            <AboutUsContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-initialmessage" role="tabpanel" aria-labelledby="pills-initialmessage-tab">
                            <InitialMessageContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-declara" role="tabpanel" aria-labelledby="pills-declara-tab">
                            <DeclarationContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-observer" role="tabpanel" aria-labelledby="pills-observer-tab">
                            <ObserverContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-etic" role="tabpanel" aria-labelledby="pills-etic-tab">
                            <EticContainer />
                        </div>
                        <div className="tab-pane fade" id="pills-aviso" role="tabpanel" aria-labelledby="pills-aviso-tab">
                            <AvisoContainer />
                        </div>
                    </div>
                </div>
            </div>
        )}
        </>
    )
})

export default Admin